import { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import { addUpdateBanner, getBanners } from "../../actions";

export const useBannersHook = () => {
   const [paginationData, setPaginationData] = useState({
      limit: 10,
      skip: 0,
      page: 0,
      total: 0
   })

   const [isLoading, setIsLoading] = useState(true);
   const [banners, setBanners] = useState([])
   const [tableKey, setTableKey] = useState(0)
   const [showAddBannerModal, setShowAddBannerModal] = useState(false)
   const [showDeleteBannerModal, setShowDeleteBannerModal] = useState(false)
   const [selectedBannerData, setSelectedBannerData] = useState({})
   const [bannerStatusUpdateData, setBannerStatusUpdateData] = useState({
      bannerIndex: -1,
      isLoading: false
   })

   useEffect(() => {
      const updatedPaginationData = {
         limit: paginationData.limit || 10,
         skip: 0,
         page: 0,
         total: 0
      }

      fetchBannersList({ ...updatedPaginationData })
   }, [])

   const fetchBannersList = async (updatedPaginationData = { ...paginationData }, filterData = {}) => {
      try {
         setIsLoading(true)
         setBanners([])

         const bannersQueryParams = {
            limit: updatedPaginationData.limit || 10,
            skip: updatedPaginationData.skip || 0,
         }

         const bannersDataRes = await getBanners(bannersQueryParams)

         let responseData = (bannersDataRes.data && bannersDataRes.data.ResponseData) || []
         let bannersData = ((responseData && responseData.banners) || [])

         const newBannersData = bannersData.map((banner) => ({
            ...banner,
            redirection_data: banner.redirection_data && banner.redirection_data.length > 0
               ? banner.redirection_data.split(",")
               : []
         }));
         setPaginationData({
            ...updatedPaginationData,
            total: responseData.total || 0,
         })

         setBanners([...newBannersData])
         setTableKey(tableKey + 1)
      } catch (error) {
         console.log(error);
      } finally {
         setIsLoading(false)
      }
   }

   const onPageChange = (activePage, selectedSize) => {
      const updatedPaginationData = {
         ...paginationData,
         page: activePage,
         limit: selectedSize,
         skip: selectedSize * activePage
      }
      fetchBannersList({ ...updatedPaginationData })
   }

   const onFilterChange = (filterData = []) => {
      const name = (filterData && filterData[0] && filterData[0].column && filterData[0].column.field) || ""
      const value = (filterData && filterData[0] && filterData[0].value) || ""
      const searchData = {
         [name]: value
      }
      fetchBannersList(paginationData, searchData)
   }

   const handleBannerStatusChange = async (isChecked, bannerIndex, bannerId) => {
      try {
         setBannerStatusUpdateData({
            bannerId: bannerId,
            bannerIndex: bannerIndex,
            isLoading: true
         })
         const statusPayload = {
            banner_id: bannerId,
            status: isChecked.toString()
         }

         const bannerStatusRes = await addUpdateBanner(statusPayload)
         toast.success("banner status updated.")

         const bannersClone = [...banners]
         bannersClone[bannerIndex].status = isChecked
         setBanners([...bannersClone])
      } catch (error) {
         console.log(error);
         toast.error("spmething went wrong while updating banner status.")
      } finally {
         setBannerStatusUpdateData({
            bannerIndex: -1,
            isLoading: false
         })
      }
   }

   const toggleAddBannerModal = (isOpen, bannerData = {}, refreshData = false) => {

      setSelectedBannerData({ ...bannerData })
      setShowAddBannerModal(isOpen)

      if (refreshData) {
         fetchBannersList()
      }
   }

   const toggleDeleteBannerModal = (isOpen, bannerData = {}, refreshData = false) => {
      setSelectedBannerData({ ...bannerData })
      setShowDeleteBannerModal(isOpen)

      if (refreshData) {
         fetchBannersList()
      }
   }

   return {
      tableKey,
      paginationData,
      isLoading,
      banners,
      bannerStatusUpdateData,
      selectedBannerData,
      showAddBannerModal,
      showDeleteBannerModal,
      handleBannerStatusChange,
      onPageChange,
      onFilterChange,
      toggleAddBannerModal,
      toggleDeleteBannerModal
   }
}